













































































import _ from 'lodash'
import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { TcwFormDate, TcwFormID } from '@/tcw/domain/types'
import * as DateUtil from '@/tcw/utils/DateUtil'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'
import { API_DAYTIME_FORMAT } from '@/tcw/domain/format'

export interface KintaiGaishutsuInfo {
  id: TcwFormID
  junban: number
  kaishi: TcwFormDate
  shuryo: TcwFormDate
  hushurou: number
  biko: string
}

@Component
export default class KintaiGaishutsuJikanFormItem extends Mixins(TcwFormItemCommon) {
  @Prop({ default: () => null })
  private userId!: TcwFormID
  @Prop({ default: () => [] })
  private value!: KintaiGaishutsuInfo[]
  @Prop({ type: Boolean, default: false })
  private clearable!: boolean

  private timeFormat: (date: Date) => string = (date: Date) => {
    return DateUtil.convertDateToStr(date, 'HH:mm')
  }
  private hourFormat = '24'

  @Emit()
  private input(gaishutsuList: KintaiGaishutsuInfo[]) {
    this.change(gaishutsuList)
  }

  @Emit()
  private change(_gaishutsuList: KintaiGaishutsuInfo[]) {
    /** */
  }

  private updateRecord(
    idx: number,
    column: keyof KintaiGaishutsuInfo,
    value: number | string | TcwFormDate
  ) {
    const newList = _.cloneDeep(this.value)

    const record = newList[idx]
    if (value instanceof Date) {
      value = DateUtil.convertDateToStr(value, API_DAYTIME_FORMAT)
    }
    if (record) {
      ;(record[column] as number | string | TcwFormDate) = value
    }
    this.input(newList)
  }

  private addGaishutsu() {
    let newList = _.cloneDeep(this.value)
    const newRecord: KintaiGaishutsuInfo = {
      id: null,
      junban: _.isArray(this.value) ? this.value.length + 1 : 1,
      kaishi: null,
      shuryo: null,
      hushurou: 0,
      biko: ''
    }

    if (newList) {
      newList.push(newRecord)
    } else {
      newList = [newRecord]
    }
    this.input(newList)
  }

  private removeGaishutsu(idx: number) {
    let newList = _.cloneDeep(this.value)
    newList = newList.filter((r, i) => i !== idx)
    newList = newList.map((r, i) => {
      r.junban = i + 1
      return r
    })
    this.input(newList)
  }
}
